import React from "react";
import { Box } from "@mui/material";
import ExpenseListTab from "./ExpenseListTab";
// 定期支出機能は一旦停止。将来復活予定 (コンポーネントは退避済み):
// import RecurringExpenseTab from "./RecurringExpenseTab";

/**
 * 支出まとめサブタブ (収支 > 支出まとめ)
 *
 * 現在: 支出一覧のみ表示
 * TODO: 定期支出 (RecurringExpenseTab) は後日復活。その際はタブ UI 化する
 */

interface ExpenseSummarySubTabProps {
  propertyId: string;
  propertyName?: string;
}

const ExpenseSummarySubTab: React.FC<ExpenseSummarySubTabProps> = ({
  propertyId,
  propertyName,
}) => {
  return (
    <Box>
      <ExpenseListTab propertyId={propertyId} propertyName={propertyName} />
    </Box>
  );
};

export default ExpenseSummarySubTab;
